import React, { useState } from 'react';
import {
  IconButton,
  SimpleGrid,
  Button,
  Box,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { FaUser } from 'react-icons/fa';
import { getData } from '../../utils/httpClient';
import AppointmentEntityDrawer, { DetailItem } from './AppointmentEntityDrawer';

const unwrapCustomer = (response) =>
  response?.payload?.customer ?? (response?.id ? response : null);

const AppointmentCustomerActions = ({
  selectedCustomer,
  selectedVehicle,
  onChangeCustomer,
}) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [customerDetail, setCustomerDetail] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openDetail = async () => {
    if (!selectedCustomer?.id) return;
    setLoading(true);
    setCustomerDetail(null);
    onOpen();
    try {
      const response = await getData(`/customers/${selectedCustomer.id}`);
      const customer = unwrapCustomer(response);
      if (!customer) throw new Error('Sin datos');
      setCustomerDetail(customer);
    } catch {
      onClose();
      toast({
        title: 'Error',
        description: 'No se pudo cargar el detalle del cliente.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChangeCustomer = () => {
    if (!selectedVehicle) return;
    onClose();
    onChangeCustomer?.();
  };

  return (
    <>
      <IconButton
        size="sm"
        variant="ghost"
        colorScheme="gray"
        aria-label="Detalle del cliente"
        icon={<Box as={FaUser} boxSize="14px" />}
        isDisabled={!selectedCustomer?.id}
        isLoading={loading && !isOpen}
        onClick={openDetail}
      />

      <AppointmentEntityDrawer
        isOpen={isOpen}
        onClose={onClose}
        title="Detalle del cliente"
        loading={loading}
        footer={
          <Button w="100%" onClick={onClose}>
            Cerrar
          </Button>
        }
      >
        {customerDetail && (
          <>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={6}>
              <DetailItem label="Nombre" value={customerDetail.name} />
              <DetailItem label="Documento" value={customerDetail.document} />
              <DetailItem label="Teléfono" value={customerDetail.phone} />
              <DetailItem label="Email" value={customerDetail.email} />
              <DetailItem label="Dirección" value={customerDetail.address} />
              <DetailItem
                label="Tipo de cliente"
                value={customerDetail.customerType?.type}
              />
              <DetailItem
                label="País"
                value={customerDetail.locality?.department?.country?.name}
              />
              <DetailItem
                label="Departamento"
                value={customerDetail.locality?.department?.name}
              />
              <DetailItem
                label="Localidad"
                value={customerDetail.locality?.name}
              />
              <DetailItem
                label="Cliente habitual"
                value={customerDetail.regularCustomer ? 'Sí' : 'No'}
              />
            </SimpleGrid>
            <Button
              w="100%"
              colorScheme="gray"
              variant="outline"
              onClick={handleChangeCustomer}
              isDisabled={!selectedVehicle}
            >
              Cambiar cliente
            </Button>
          </>
        )}
      </AppointmentEntityDrawer>
    </>
  );
};

export default AppointmentCustomerActions;
